import * as types from './mutation-types'
import {api} from "~/config/api";

export default {
  async storeUserClick({ commit }, payload) {
    const { type = null } = payload
    try {
      if (!type) throw new Error('No click type')
      else commit(types.SET_USER_CLICK_TYPE, type)

      await this.$axios.post(
        `/${api.USER_CLICKS}/${type}`
      )
      return true
    } catch (e) {
      console.error('User click storing failed', e)
    }
  }
}
